import * as React from 'react';
import tombacIcon from '../tombacIcon';

function SvgRocket(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="4 0 16 24" {...props}>
      <path
        d="M9.509 15.611s.034 1.842-3.663 1.606c-.237-3.697 1.605-3.662 1.605-3.662l.396.394a.037.037 0 010 .05c-.216.215-.422.659-.363 1.58.922.059 1.366-.147 1.582-.362.013-.014.035-.013.049 0l.394.394zm7.644-7.003a1.93 1.93 0 01-2.346.007 1.928 1.928 0 01-.003-3.058 1.928 1.928 0 012.345 0 1.927 1.927 0 01.004 3.051m2.643-5.32c-1.848-.515-4.4.28-6.569 1.847-1.144.827-2.212 1.814-3.123 2.754l-.013-.013-1.508.103a.177.177 0 00-.06.02l-4.461 2.803a.132.132 0 00.046.242l3.372.623c.052.01.1.036.139.073l.473.473-.316.316a.265.265 0 000 .374l2.384 2.384a.264.264 0 00.375 0l.315-.316.474.474a.28.28 0 01.073.139l.623 3.372a.132.132 0 00.242.046l2.802-4.46a.138.138 0 00.02-.063l.095-1.392a.264.264 0 01.08-.17c.92-.897 1.88-1.943 2.689-3.06 1.568-2.169 2.361-4.721 1.848-6.568"
        fill="currentColor"
      />
    </svg>
  );
}

export default tombacIcon('Rocket')(SvgRocket);
